import React, { useCallback, useState } from "react";   
import { Link, useSearchParams } from "react-router-dom";
import profile from "../../images/Icons/man.png";
import camera from "../../images/Icons/camera.png";
import success from "../../images/Icons/success.png";
import pending from "../../images/Icons/pending.png";
import rejected from "../../images/Icons/rejected.png";
import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";
import { toast } from "react-toastify";
import useLogout from "../Auth/useLogout";

export default function BuyerProfile() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [businessType, setBusinessType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const logout = useLogout();
  
  const shouldStartInEditMode = searchParams.get('edit') === 'true';
  
  useEffect(() => {
    axios
      .get(`${config.apiUrl}/registration-form-info`)
      .then((res) => {
        setBusinessType(res.data.business_type);
      })
      .catch((error) => { });
  }, []);
  const [responseError, setResponseError] = useState({
    nameError: "",
    companyNameError: "",
    emailError: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    company_name: "",
    gst_number: "",
    pan_number: "",
    company_address: "",
    phone: "",
    email: "",
    type: "",
    kyc_status: "",
    address_line_one: "",
    address_line_two: "",
    postal_code: "",
    city: "",
    state: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/customer/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setData(response.data.data);
      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        company_name: response.data.data.user_detail?.company_name ?? "",
        gst_number: response.data.data.user_detail?.gst_number ?? "",
        pan_number: response.data.data.user_detail?.pan_number ?? "",
        company_address: response.data.data.user_detail?.company_address ?? "",
        phone: response.data.data.phone ?? "",
        email: response.data.data.email ?? "",
        type: response.data.data.user_detail?.type?.[0]?.id ?? "",
        kyc_status: response.data.data.kyc_status ?? "",
        address_line_one: response.data.data.user_detail?.address_line_one ?? "",
        address_line_two: response.data.data.user_detail?.address_line_two ?? "",
        city: response.data.data.user_detail?.city ?? "",
        state: response.data.data.user_detail?.state ?? "",
        postal_code: response.data.data.user_detail?.postal_code ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateData = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.nameError = "Name is required";
    }
    if (!formData.company_name) {
      newErrors.companyNameError = "Company name is required";
    }

    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.emailError = "Invalid email format";
      }
    }

    if (!formData.email) {
      newErrors.emailError = "Email is required";
    }



    setResponseError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateData()) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/customer/update-profile`,
          {
            name: formData.name,
            company_name: formData.company_name,
            email: formData.email,
            type: formData.type ? [+formData.type] : [],
            gst_number: formData.gst_number,
            pan_number: formData.pan_number,
            company_address: formData.company_address,
            address_line_one: formData.address_line_one,
            address_line_two: formData.address_line_two,
            city: formData.city,
            state: formData.state,
            pin_code: formData.postal_code,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        var localData = {
          name: response.data.data.name,
          type: response.data.data.type,
          email: response.data.data.email,
          phone: response.data.data.phone,
        };

        Cookies.set("bz_uinf", JSON.stringify(localData), { expires: 7 });
        config.user =
          Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setMode("show");
        
        if (searchParams.get('edit') === 'true') {
          setSearchParams({}, { replace: true });
        }
        
        fetchUserProfile();
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const [mode, setMode] = useState(shouldStartInEditMode ? "edit" : "show");
  const handleMode = (mode) => {
    setMode(mode);
  };
  const user = config.user;
  const userType = user ? user.type : "";

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="row-layout dashborad-profile">
                <div className="card mb-2">
                  <div className="card-body p-0">
                    <div className="user-image">
                      <img src={profile} alt="" />
                      <div className="edit-image" title="User Profile">
                        <img src={camera} alt="" />
                      </div>
                    </div>
                    <h6 className="text-center mt-1 mb-0">{formData.name}</h6>
                    {data.is_staff ? (
                      <p className="text-center m-0 text-capitalize">
                        {userType && "Buyer"} Staff ({data.role ?? "N/A"})
                      </p>
                    ) : (
                      <p className="text-center m-0 text-capitalize">
                        {userType}/Buyer
                      </p>
                    )}
                    <div className="row-hd-txt-center">
                      {formData.kyc_status === "pending" ? (
                        <>
                          <img src={pending} alt="icon" />
                          <h5 className="text-pending">Pending</h5>
                        </>
                      ) : formData.kyc_status === "approved" ? (
                        <>
                          <img src={success} alt="icon" />
                          <h5 className="text-success">Approved</h5>
                        </>
                      ) : formData.kyc_status === "rejected" ? (
                        <>
                          <img src={rejected} alt="icon" />
                          <h5 className="text-danger">Rejected</h5>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="row align-items-center">
                  <div className="col-6">
                    <h6 className="mb-0">
                      {mode === "show" ? "Personal" : "Edit"} Information
                    </h6>
                  </div>
                  <div className="col-6 text-end">
                    {mode === "show" ? (
                      <button
                        type="button"
                        className="add-edit-btn"
                        onClick={() => handleMode("edit")}
                      >
                        <i className="bi bi-pencil"></i>Edit
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="add-edit-btn"
                        onClick={() => handleMode("show")}
                      >
                        <i className="bi bi-x-lg"></i>Cancel
                      </button>
                    )}
                    <Link to="/address" type="button" className="add-edit-btn ms-2">
                      <i className="bi bi-chevron-double-right"></i>Next
                    </Link>
                  </div>
                </div>

                {mode === "show" ? (
                  <div className="row mt-2">
                    <div className="col-lg-12">
                      <table className="table table-bordered detail_table">
                        <tbody>
                          <tr>
                            <td>Name:</td>
                            <td>
                              <span>{formData.name}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Company Name:</td>
                            <td>
                              <span>{formData.company_name || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>GST Number:</td>
                            <td>
                              <span>{formData.gst_number || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Pan Number:</td>
                            <td>
                              <span>{formData.pan_number || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Company Address:</td>
                            <td>
                              <span>{formData.company_address || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Phone Number:</td>
                            <td>
                              <span>{formData.phone}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Email Address:</td>
                            <td>
                              <span>{formData.email || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Business Type:</td>
                            <td>
                              <span>
                                {formData.type
                                  ? businessType.find(
                                    (b) => b.id === formData.type
                                  )?.name
                                  : "---"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Address Line One:</td>
                            <td>
                              <span>{formData.address_line_one || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Address Line Two:</td>
                            <td>
                              <span>{formData.address_line_two || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>City:</td>
                            <td>
                              <span>{formData.city || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>State:</td>
                            <td>
                              <span>{formData.state || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Pin Code:</td>
                            <td>
                              <span>{formData.postal_code || "---"}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <form className="dashboard-form mt-1" onSubmit={handleSubmit}>
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <label className="label" htmlFor="name">
                          Name
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter buyer name"
                          />
                        </div>
                        {responseError.nameError && (
                          <small className="input-error">
                            {responseError.nameError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="company_name">
                          Company Name
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="company_name"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            placeholder="Enter company name"
                          />
                        </div>
                        {responseError.companyNameError && (
                          <small className="input-error">
                            {responseError.companyNameError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="type">
                          Choose Business Type(If any)
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-box-fill"></i>
                          </span>
                          <select
                            className="form-control"
                            id="type"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select Type
                            </option>
                            {businessType.map((btype) => {
                              return (
                                <option value={btype.id} key={btype.id}>
                                  {btype.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="email">
                          Email
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-envelope-fill"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Enter email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                        {responseError.emailError ? (
                          <small className="input-error">
                            {" "}
                            {responseError.emailError}{" "}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="gst">
                          Gst Number
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="gst"
                            placeholder="Enter Gst Number"
                            name="gst_number"
                            value={formData.gst_number}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="pan">
                          Pan Number
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="pan"
                            placeholder="Enter Pan Number"
                            name="pan_number"
                            value={formData.pan_number}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label" htmlFor="address_line_one">
                          Address Line One
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="address_line_one"
                            placeholder="Enter address line one"
                            name="address_line_one"
                            value={formData.address_line_one}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <label className="form-label" htmlFor="address_line_two">
                          Address Line Two
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="address_line_two"
                            placeholder="Enter address line two"
                            name="address_line_two"
                            value={formData.address_line_two}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="city">
                          City
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            placeholder="Enter city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="state">
                          State
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                            placeholder="Enter state"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="pincode">
                          Pincode
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="number"
                            className="form-control"
                            id="pincode"
                            placeholder="Enter pincode"
                            name="postal_code"
                            value={formData.postal_code}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-12">
                        <label className="form-label" htmlFor="company_address">
                          Company Address
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="company_address"
                            placeholder="Enter company address"
                            name="company_address"
                            value={formData.company_address}
                            onChange={handleChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-lg-12 text-end">
                        <button
                          type="submit"
                          title="Update Profile"
                          className="submit_btn"
                          disabled={loading}
                        >
                          <i className="bi bi-floppy"></i>
                          {loading ? "Submitting" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
